"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.normalizeThirdPartyId = exports.KNOWN_NON_WEBSITE_MARKETPLACES = void 0;
exports.KNOWN_NON_WEBSITE_MARKETPLACES = [
    "amazon",
    "deliverr",
    "ebay",
    "etsy",
    "google",
    "macys",
    "michaels",
    "michaels us",
    "target",
    "walmart",
    "wish",
];
const normalizeThirdPartyId = (name) => {
    if (/Walmart/i.test(name)) {
        return "walmart";
    }
    if (/airshop/i.test(name)) {
        return "airshop";
    }
    if (/amazon/i.test(name)) {
        return "amazon";
    }
    if (/ebay/i.test(name)) {
        return "ebay";
    }
    if (/etsy/i.test(name)) {
        return "etsy";
    }
    if (/google/i.test(name)) {
        return "google";
    }
    if (/macys/i.test(name)) {
        return "macys";
    }
    if (/michaels us/i.test(name)) {
        return "michaels us";
    }
    if (/michaels/i.test(name)) {
        return "michaels";
    }
    if (/shopify/i.test(name)) {
        return "shopify";
    }
    if (/target/i.test(name)) {
        return "target";
    }
    if (/wish/i.test(name)) {
        return "wish";
    }
    return name.toLowerCase();
};
exports.normalizeThirdPartyId = normalizeThirdPartyId;
//# sourceMappingURL=MarketplaceUtils.js.map